import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Link from '@mui/material/Link';
import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuIcon from '@material-ui/icons/Menu';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
//import AssessmentIcon from '@material-ui/icons/Assessment';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
//import AssignmentIcon from '@material-ui/icons/Assignment';
//import DescriptionIcon from '@mui/icons-material/Description';
import LogoutIcon from '@mui/icons-material/Logout';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
});

export default function SwipeableTemporaryDrawer() {
  const userObj = useSelector(state => state.userDetails);
  const [topicSubList, setTopicSubList] = React.useState(false);
  const [learningSubList, setLearningSubList] = React.useState(false);
  const [questionSubList, setQuestionSubList] = React.useState(false);
  const [selfTestSubList, setSelfTestSubList] = React.useState(false);
  const [patternSubList, setPatternSubList] = React.useState(false);
  const [asmtSubList, setAsmtSubList] = React.useState(false);
  const [mockTestSubList, setMockTestSubList] = React.useState(false);
  const [topicTestSubList, setTopicTestSubList] = React.useState(false);
  const [otherSubList, setOtherSubList] = React.useState(false);

  
  const classes = useStyles();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  function handleClickTopicSubList(){    
    setTopicSubList(!topicSubList);
  };
  function handleClickLearningSubList(){    
    setLearningSubList(!learningSubList);
  };
  function handleClickSelfTestSubList(){    
    setSelfTestSubList(!selfTestSubList);
  };
  function handleClickPatternSubList(){    
    setPatternSubList(!patternSubList);
  };
  function handleClickMockTestSubList(){    
    setMockTestSubList(!mockTestSubList);
  };
  function handleClickTopicTestSubList(){    
    setTopicTestSubList(!topicTestSubList);
  };
  function handleClickAsmtSubList(){    
    setAsmtSubList(!asmtSubList);
  };
  function handleClickOtherSubList(){    
    setOtherSubList(!otherSubList);
  };
  function handleClickQuestionSubList(){    
    setQuestionSubList(!questionSubList);
  };

  const toggleDrawer = (anchor, open) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  // function goToLocation(url){
  //   window.location=url;
  // }
  function logout(){
    Cookies.remove('isadminloggedin');
    window.location.href='login';
  }


  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === 'top' || anchor === 'bottom',
      })}
      role="presentation"      
      // onClick={toggleDrawer(anchor, false)}
      // onKeyDown={toggleDrawer(anchor, false)}
    >
      <Stack direction="row" spacing={2} style={{margin: 20}} >
        <Avatar alt={userObj.fullName} src="/static/images/avatar/1.jpg" sx={{ width: 29, height: 29, marginRight:1 }} />
        <span style={{marginTop: 1, fontSize: 14}} >{userObj.fullName}</span>
      </Stack>
      <Divider />

      {/* {userObj.navigation?userObj.navigation.map((myRow,index)=>(
        <ListItem key={'n'+index} button onClick={()=>{goToLocation(myRow.url)}} >
            <ListItemIcon><DescriptionIcon /></ListItemIcon>
            <ListItemText primary={myRow.label} />
        </ListItem>
      )):null} */}


      <ListItemButton onClick={()=>{handleClickTopicSubList();toggleDrawer('left', true)}} >
        <ListItemIcon>
          <LibraryBooksIcon />
        </ListItemIcon>
        <ListItemText primary="Topics Mgmt." />
        {topicSubList ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={topicSubList} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <Link href={'topics'} style={{color:'#000',textDecoration:'none'}} >
          <ListItem button >
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary={'Topics'} />
          </ListItem>
          </Link>
          <Link href={'topics-templates'} style={{color:'#000',textDecoration:'none'}} >
          <ListItem button >
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary={'Topics Treeview Templates'} />
          </ListItem>        
          </Link>
        </List>
      </Collapse>


      <ListItemButton onClick={()=>{handleClickSelfTestSubList();toggleDrawer('left', true)}} >
        <ListItemIcon>
          <LibraryBooksIcon />
        </ListItemIcon>
        <ListItemText primary="SelfTest Mgmt." />
        {selfTestSubList ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={selfTestSubList} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <Link href={'selftest-options-objective'} style={{color:'#000',textDecoration:'none'}} >
          <ListItem button >
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary={'Selftest Options (Obj.)'} />
          </ListItem>
          </Link>
          <Link href={'selftest-options-subjective'} style={{color:'#000',textDecoration:'none'}} >
          <ListItem button >
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary={'Selftest Options (Sub.)'} />
          </ListItem> 
          </Link>
        </List>
      </Collapse>


      <ListItemButton onClick={()=>{handleClickPatternSubList();toggleDrawer('left', true)}} >
        <ListItemIcon>
          <LibraryBooksIcon />
        </ListItemIcon>
        <ListItemText primary="Pattern Mgmt." />
        {patternSubList ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={patternSubList} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <Link href={'test-patterns'} style={{color:'#000',textDecoration:'none'}} >
          <ListItem button >
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary={'Test Patterns'} />
          </ListItem>
          </Link>
          <Link href={'test-pattern-section'} style={{color:'#000',textDecoration:'none'}} >
          <ListItem button >
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary={'Section'} />
          </ListItem>
          </Link>
          <Link href={'test-pattern-defination'} style={{color:'#000',textDecoration:'none'}} >
          <ListItem button >
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary={'Patern Defination'} />
          </ListItem>
          </Link>

        </List>
      </Collapse>


      <ListItemButton onClick={()=>{handleClickMockTestSubList();toggleDrawer('left', true)}} >
        <ListItemIcon>
          <LibraryBooksIcon />
        </ListItemIcon>
        <ListItemText primary="MockTest Mgmt." />
        {mockTestSubList ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={mockTestSubList} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <Link href={'mocktest-templates'} style={{color:'#000',textDecoration:'none'}} >
          <ListItem button >
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary={'Mocktest Templates'} />
          </ListItem>
          </Link>
          <Link href={'mocktest-category'} style={{color:'#000',textDecoration:'none'}} >
          <ListItem button >
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary={'Mocktest Category'} />
          </ListItem>
          </Link>
          <Link href={'mocktest-mgmt'} style={{color:'#000',textDecoration:'none'}} >
          <ListItem button >
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary={'Mocktest Mgmt'} />
          </ListItem>
          </Link>


        </List>
      </Collapse>


      <ListItemButton onClick={()=>{handleClickTopicTestSubList();toggleDrawer('left', true)}} >
        <ListItemIcon>
          <LibraryBooksIcon />
        </ListItemIcon>
        <ListItemText primary="TopicTest Mgmt." />
        {topicTestSubList ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={topicTestSubList} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <Link href={'topictest-templates'} style={{color:'#000',textDecoration:'none'}} >
          <ListItem button >
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary={'Topictest Templates'} />
          </ListItem>
          </Link>
        </List>
      </Collapse>


      <ListItemButton onClick={()=>{handleClickAsmtSubList();toggleDrawer('left', true)}} >
        <ListItemIcon>
          <LibraryBooksIcon />
        </ListItemIcon>
        <ListItemText primary="Course Asmt Mgmt." />
        {asmtSubList ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={asmtSubList} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
  
          <Link href={'qt-templates'} style={{color:'#000',textDecoration:'none'}} >
          <ListItem button >
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary={'Question Type Template'} />
          </ListItem>
          </Link>

          <Link href={'exam-templates'} style={{color:'#000',textDecoration:'none'}} >
          <ListItem button >
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary={'Course Templates'} />
          </ListItem> 
          </Link>
  
          <Link href={'exam-limit-objective'} style={{color:'#000',textDecoration:'none'}} >
          <ListItem button >
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary={'Assessment Limit (Obj.)'} />
          </ListItem>
          </Link>
  
          <Link href={'exam-limit-subjective'} style={{color:'#000',textDecoration:'none'}} >
          <ListItem button >
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary={'Assessment Limit (Sub.)'} />
          </ListItem>
          </Link>

          <Link href={'content-limits'} style={{color:'#000',textDecoration:'none'}} >
          <ListItem button >
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary={'Content Limit'} />
          </ListItem>
          </Link>

        </List>
      </Collapse>



      {/* <ListItemButton onClick={()=>{handleClickLearningSubList();toggleDrawer('left', true)}} >
        <ListItemIcon>
          <LibraryBooksIcon />
        </ListItemIcon>
        <ListItemText primary="Learning Content" />
        {learningSubList ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={learningSubList} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <Link href={'topic-contents'} style={{color:'#000',textDecoration:'none'}} >
          <ListItem button >
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary={'Smart Learning: Topics'} />
          </ListItem>
          </Link>
          <Link href={'keyword-contents'} style={{color:'#000',textDecoration:'none'}} >
          <ListItem button >
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary={'Smart Learning: Keywords'} />
          </ListItem>
          </Link>
        </List>
      </Collapse> */}


      <ListItemButton onClick={()=>{handleClickQuestionSubList();toggleDrawer('left', true)}} >
        <ListItemIcon>
          <LibraryBooksIcon />
        </ListItemIcon>
        <ListItemText primary="Question Mgmt." />
        {questionSubList ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={questionSubList} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <Link href={'questions-upload'} style={{color:'#000',textDecoration:'none'}} >
            <ListItem button >
                <ListItemIcon><ArrowRightIcon /></ListItemIcon>
                <ListItemText primary={'Qb Upload'} />
            </ListItem>
          </Link>
          <Link href={'questions-download'} style={{color:'#000',textDecoration:'none'}} >
            <ListItem button >
                <ListItemIcon><ArrowRightIcon /></ListItemIcon>
                <ListItemText primary={'Qb Download'} />
            </ListItem>
          </Link>
          <Link href={'question-bank'} style={{color:'#000',textDecoration:'none'}} >
            <ListItem button >
                <ListItemIcon><ArrowRightIcon /></ListItemIcon>
                <ListItemText primary={'Qb Management'} />
            </ListItem>
          </Link>
        </List>
      </Collapse>


      <ListItemButton onClick={()=>{handleClickOtherSubList();toggleDrawer('left', true)}} >
        <ListItemIcon>
          <LibraryBooksIcon />
        </ListItemIcon>
        <ListItemText primary="Others" />
        {otherSubList ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={otherSubList} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>

          <Link href={'keywords'} style={{color:'#000',textDecoration:'none'}} >
          <ListItem button >
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary={'Keywords'} />
          </ListItem>
          </Link>

          <Link href={'subjects'} style={{color:'#000',textDecoration:'none'}} >
          <ListItem button >
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary={'Subjects'} />
          </ListItem>
          </Link>
          <Link href={'grades'} style={{color:'#000',textDecoration:'none'}} >
          <ListItem button >
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary={'Grades / Class'} />
          </ListItem>
          </Link>
          <Link href={'difficulty'} style={{color:'#000',textDecoration:'none'}} >
          <ListItem button >
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary={'Question Difficulty'} />
          </ListItem>
          </Link>
          <Link href={'languages'} style={{color:'#000',textDecoration:'none'}} >
          <ListItem button >
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary={'Languages'} />
          </ListItem>
          </Link>
          <Link href={'question-types'} style={{color:'#000',textDecoration:'none'}} >
          <ListItem button >
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary={'Question Types'} />
          </ListItem>
          </Link>
          {/* <Link href={'qt-templates'} style={{color:'#000',textDecoration:'none'}} >
          <ListItem button >
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary={'Question Type Template'} />
          </ListItem>
          </Link> */}
          <Link href={'tags'} style={{color:'#000',textDecoration:'none'}} >
          <ListItem button >
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary={'Tags'} />
          </ListItem>
          </Link>
        </List>
      </Collapse>





      <ListItem button onClick={()=>{logout()}} >
            <ListItemIcon><LogoutIcon /></ListItemIcon>
            <ListItemText primary="Logout" />
      </ListItem>
      
    </div>
  );

  return (
    <div>
          <Button style={{color:'#FFFFFF'}} onClick={toggleDrawer('left', true)}><MenuIcon /></Button>
          <SwipeableDrawer
            anchor='left'
            open={state['left']}
            onClose={toggleDrawer('left', false)}
            onOpen={toggleDrawer('left', true)}
          >
            {list('left')}
          </SwipeableDrawer>
    </div>
  );
}
